import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "nav-section" }
const _hoisted_2 = { class: "left flex flex-middle" }
const _hoisted_3 = {
  key: 2,
  class: "nav-title"
}
const _hoisted_4 = { class: "right flex" }
const _hoisted_5 = { class: "yddbtn" }

import { getCurrentInstance, computed } from "vue"
	import { useModuleMapState } from '@/config/useMapState'
	import { useStore } from 'vuex'
	import { localDel } from '@/config/storage'
	import { signOut } from '@/request/api/auth'
	
	
export default /*@__PURE__*/_defineComponent({
  __name: 'Nav',
  setup(__props) {

	const {commit, state} = useStore()
	
	const { isCollapse, account, avatar, personInfo } = useModuleMapState('publicOptions', ['isCollapse', 'account', 'avatar', 'personInfo'])
	
	const navTitle = computed(() => {
		let list = []
		let title = state.publicOptions.personInfo.title
		if(title) list = title.split('-')
		return list
	})
	const collapseClick = (state:string) => {
		switch (state) {
			case 'open':
				commit("publicOptions/MENU_COLLAPSE", true)
		    break
			case 'close':
				commit("publicOptions/MENU_COLLAPSE", false)
		    break
		}
	}
	const {$confirm, $message, $router} = getCurrentInstance().appContext.config.globalProperties
	const toLogout = () => {
		$confirm('是否退出登录?', '系统提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
		  try {
		    const { code, message } = await signOut()
		    if (code === 200) {
		      $message.success(message)
		      commit("publicOptions/SAVE_TOKEN", '') //删除vuex中的token
		      localDel('token')
			  commit("publicOptions/SAVE_AVATAR", '') //删除vuex中的token
			  localDel('avatar')
		      $router.replace('/login')
		    }
		  } catch (error) {
		    console.log(error)
		  }
		}).catch(() => {
			
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_Fold = _resolveComponent("Fold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "nav",
      justify: "space-between",
      align: "middle"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_unref(isCollapse))
            ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (collapseClick('close')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Fold)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (collapseClick('open')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Expand)
                ]),
                _: 1
              })),
          (_unref(personInfo).title)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navTitle.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(["span", `span${index + 1}`]),
                    key: index
                  }, _toDisplayString(item), 3))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(account)), 1),
          _createElementVNode("div", {
            class: "yddbtn pointer",
            onClick: toLogout
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_SwitchButton)
              ]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createTextVNode("退出 "))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})